import React, { useRef, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { FlexByRow, XDivider, YDivider, HalfScreen } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
import { CancelButton, SaveButton, TextField, Autocomplete } from 'irmlib/components/FormControls'
// import { LocalToast, setBusy, clearBusy } from 'irmlib/containers'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import styled from 'styled-components'
import * as routePaths from '../../../navigation/routePaths'
import { getUser } from '../../../redux/global'
import { successToast } from '../../../common/functions'
import { LocalToast, setBusy, clearBusy, closeGeneralDialog, openGeneralDialog } from '../../../irmlib/src/containers'
import { ContainedButton, Label, OutlinedButton } from 'irmlib/components/Controls'
// import moment from 'moment'
import { useTranslation } from 'react-i18next'

const VerticalDivider = () =>
  <YDivider height='50px' />

const getService = async () => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

const CardBodyContainer = styled.div`
  width: 70%;
`

const rowHeight = '40px'
export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 12px;
`

const TableHeaderRow = styled.tr`
  height: ${rowHeight};
`

const TableRow = styled.tr`
  height: ${rowHeight};
  border-top: 1px solid rgb(66, 66, 66);
`
const TableHeader = styled.td`
  font-weight: bold;
`
const AdditionalTitle = styled.div`
  padding-top: 11px;
  padding-bottom: 11px;
  color: red;
  font-weight: bold;
`

const SELECT_JOB_ID = 0
const SELECT_UNIQUE_FIELD = 1

const initialSate = {
  jobIds: [],
  selectdTemplateFields: [],
  templateFieldsArrayForSelection: [],
  jobDetails: {},
}

const UploadCustomerData = () => {
  const { t } = useTranslation()
  const refLocalToast = useRef(null)
  const [state, setState, getState] = useMergeState(initialSate)
  const [csvFile, setCsvFile] = useState()
  const [errorsList, setErrorsList] = useState()
  const refLocalBusyCursor = useRef(null)
  const history = useHistory()
  let jobId
  const location = useLocation()
  const JobId = location.pathname.split('/')[2]

  const Buttons = props =>
    <>
      <CancelButton id={'assignJob_cancel'} onClick={props.onCancelUpload} arrRefs={props.arrRefs} />
      <XDivider width='10px' />
      <SaveButton id={'assignJob_save'} disabled={getState().isSubmit} arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.uploadCustomerData' />
    </>

  Buttons.propTypes = {
    arrRefs: PropTypes.array,
    postService: PropTypes.func,
    onCancelUpload: PropTypes.func
  }

  const formTemplate = [
    {
      label: 'demo.jobID',
      fieldKey: 'jobID',
      isRequired: true,
      isRequiredError: 'forms.required',
      defaultValue: JobId,
    },
    {
      label: 'demo.uniqueField',
      fieldKey: 'uniqueField',
      isRequired: true,
      isRequiredError: true,
    },
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  useEffect(() => {
    if (location.pathname.split('/').length > 2) {
      getJobDetails()
    }
  }, [])

  const handleExistingUpload = () => {
    openGeneralDialog({
      title: t('messages.deleteExistingUploadTitle'),
      message: t('messages.deleteExistingUploadMsg'),
      translateMessage: false,
      noTranslateTitle: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  const ButtonsForCancelDialogBox = (props) =>
    <>
      <OutlinedButton onClick={handleDoNotDeleteUploadData} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleDeleteUploadData} >buttons.yes</ContainedButton>
    </>

  const handleDoNotDeleteUploadData = async() => {
    setBusy()
    setTimeout(history.push(`${routePaths.AllOpenJobs}`), 2000)
    closeGeneralDialog()
    clearBusy()
  }

  const handleDeleteUploadData = async() => {
    setBusy()
    const JobId = location.pathname.split('/')[2]
    const uploadedData = await gdeTransactions.getUploadCollection(JobId)
    uploadedData.forEach(async(doc) => {
      const data = doc.data()
      await gdeTransactions.deleteUploadCollection(JobId, data.uniqueCollectionId)
    })
    await gdeTransactions.updateJob(JobId, { uniqueFieldKeyToUploadData: '', dataUploadFields: '' })
    closeGeneralDialog()
    clearBusy()
  }

  const getJobDetails = async () => {
    setBusy()
    const user = getUser()
    jobId = location.pathname.split('/')[2]
    const jobData = await gdeTransactions.getJobById(jobId)
    const jobDetails = jobData.data()
    let selectdTemplateFields = []
    const templateFieldsArrayForSelection = []
    const templateDetails = jobDetails.templateData
    const uniqueFieldKeyToUploadData = jobDetails?.uniqueFieldKeyToUploadData
    const isUploadCustomerDataFile = jobDetails?.isUploadCustomerDataFile
    const templateFields = jobDetails.templateData.templateFields

    if (isUploadCustomerDataFile === true && uniqueFieldKeyToUploadData !== '' && uniqueFieldKeyToUploadData !== undefined) {
      handleExistingUpload(jobId)
    }

    selectdTemplateFields = Object.keys(templateFields).map((key) => {
      const customFieldName = templateFields[key].customName
      return {
        value: key,
        label: customFieldName,
        isRequired: templateFields[key].isRequired,
        doNotDuplicate: templateFields[key].doNotDuplicate,
        verify: templateFields[key].verify,
        defaultValue: templateFields[key].defaultValue,
        customFormat: templateFields[key].customFormat,
      }
    })

    selectdTemplateFields.forEach((doc) => {
      if (doc.isRequired === true && doc.value !== 'customerId' && doc.value !== 'skpBoxId' && doc.defaultValue === '') {
        templateFieldsArrayForSelection.push({ 
          value: doc.value, 
          label: doc.label, 
          isRequired: doc.isRequired,  
          doNotDuplicate: doc.doNotDuplicate,
          verify: doc.verify,
          defaultValue: doc.defaultValue,
        })
      }
    })

    setState({
      loggedInUser: user,
      jobId: jobId,
      jobDetails: jobDetails,
      templateDetails: templateDetails,
      selectdTemplateFields: selectdTemplateFields,
      templateFieldsArrayForSelection: templateFieldsArrayForSelection,
    })
    clearBusy()
  }

  const postService = async postObject => {
    document.getElementById('csv_file_error').textContent = ''
    if (arrRefs[SELECT_UNIQUE_FIELD].current.getValue() === '' || arrRefs[SELECT_UNIQUE_FIELD].current.getValue() === undefined) {
      arrRefs[SELECT_UNIQUE_FIELD].current.setErrorMsg('Required', true)
    } else if (csvFile === undefined) {
      document.getElementById('csv_file_error').textContent = 'file required'
    } else {
      const file = csvFile
      const reader = new FileReader()
      reader.onload = function (e) {
        const text = e.target.result
        processCSV(text)
      }
      reader.readAsText(file)
    }
  }

  const onCancelUpload = () => {
    history.push(`${routePaths.AllOpenJobs}`)
  }

  const errorLog = (errorRecordId, errorType, errorMessage) => {
    return { 
      errorType: errorType,
      errorMessage: errorMessage,
      errorRecordId: errorRecordId,
    }
  }

  const processCSV = async (str, delim = ',') => {
    const errorList = []
    const uniqueFieldId = arrRefs[SELECT_UNIQUE_FIELD].current.getValue()
    let uniqueFieldCustomId

    state.selectdTemplateFields.forEach((doc) => {
      if (doc.value === uniqueFieldId) {
        uniqueFieldCustomId = doc.label
      }
    })
    
    const templateFields = state.templateDetails.templateFields
    const headers = str.slice(0, str.indexOf('\n')).split(delim)

    for (let i = 0; i < headers.length; i++) {
      headers[i] = headers[i].replace('\r', '')
    }

    const rows = str.slice(str.indexOf('\n') + 1).split('\n')
    const indexOfUniqueField = headers.indexOf(uniqueFieldCustomId)
    const uniqueHeaders = headers.filter((item, index) => headers.indexOf(item) === index)

    headers.forEach((header) => {
      if (templateFields[header]?.defaultValue !== '' && templateFields[header]?.defaultValue !== undefined) {
        // eslint-disable-next-line
        errorList.push(errorLog(null, t('uploadCustomerDataErrorObj.defaultValueErr'), t('uploadCustomerDataErrorObj.defaultValueDesc1') + `${header}` + t('uploadCustomerDataErrorObj.defaultValueDesc2') + `${templateFields[header].defaultValue}` + t('uploadCustomerDataErrorObj.defaultValueDesc3')))
      }
    })
    
    if (headers.length !== uniqueHeaders.length) {
      errorList.push(errorLog(1, t('uploadCustomerDataErrorObj.duplicateHeaderErr'), t('uploadCustomerDataErrorObj.duplicateHeaderDesc')))
    } else if (indexOfUniqueField === -1) {
      // code to check unique field is available in csv or not
      // eslint-disable-next-line
      errorList.push(errorLog(null, t('uploadCustomerDataErrorObj.missingUniqueFieldErr'), t('uploadCustomerDataErrorObj.missingUniqueFieldDesc1') + `${uniqueFieldCustomId}` + t('uploadCustomerDataErrorObj.missingUniqueFieldDesc2')))
    } else {
      const newArray = rows.map((row) => {
        const values = row.split(delim)
        const eachObject = headers.reduce((obj, header, i) => {
          obj[header] = values[i]
          return obj
        }, {})
        return eachObject
      })

      // code to check unique id is present for all records or not, unique id is duplicate or not
      const arrayOfUniqueFieldIds = []
      newArray.forEach((doc, index) => {
        const indexOfUniqueFieldValue = arrayOfUniqueFieldIds.indexOf(doc[uniqueFieldCustomId])
        if (doc[uniqueFieldCustomId] === '') {
          // eslint-disable-next-line
          errorList.push(errorLog(index + 2, t('uploadCustomerDataErrorObj.blankUniqueFieldErr'), t('uploadCustomerDataErrorObj.blankUniqueFieldDesc') + ` ${index + 2}.`))
        } else {
          if (indexOfUniqueFieldValue === -1) {
            arrayOfUniqueFieldIds.push(doc[uniqueFieldCustomId])
          } else if (indexOfUniqueFieldValue !== -1) {
            // errorList.push(errorLog(index + 2, 'Duplicate Unique Field', `Unique field ${uniqueFieldCustomId} value ${doc[uniqueFieldCustomId]} at Row No. ${index + 2} is already present at Row No. ${indexOfUniqueFieldValue + 2}`))
            // const thisLogicIsBlocked = true
          }
        }
      })

      // code to check required fields, date formats
      newArray.forEach((doc, index) => {
        let processRecord = false
        Object.keys(doc).forEach(key => {
          if ((doc[key] === '\r' || doc[key] === '' || doc[key] === undefined) && processRecord === false) {
            processRecord = false
          } else {
            processRecord = true
          }
        })

        if (processRecord) {
          headers.forEach((header) => {
            // code to remove \r at the end of each row in csv file
            const indexOfSlashR = doc[header].indexOf('\r')
            if (indexOfSlashR >= 0 && indexOfSlashR + 1 === doc[header].length) {
              doc[header] = doc[header].replace('\r', '')
            }
            
            Object.keys(templateFields).forEach(key => {
              if (header === templateFields[key].customName) {
                if (templateFields[key].isRequired === true && (doc[header] === '' || doc[header] === undefined)) {
                  // eslint-disable-next-line
                  errorList.push(errorLog(index + 2, t('uploadCustomerDataErrorObj.fieldRequiredErr'), `${templateFields[key].customName}` + t('uploadCustomerDataErrorObj.fieldRequiredDesc') + `${index + 2}`))
                }
  
                if (templateFields[key].customLength < doc[header].length) {
                  // eslint-disable-next-line
                  errorList.push(errorLog(index + 2, t('uploadCustomerDataErrorObj.fieldLengthExceedErr'), `${templateFields[key].customName}` + t('uploadCustomerDataErrorObj.fieldLengthExceedDesc1') + `${templateFields[key].customLength}` + t('uploadCustomerDataErrorObj.fieldLengthExceedDesc2') + `${index + 2}`))
                }
                
                if ((templateFields[key].customFormat === 'DD/MM/YYYY' || templateFields[key].customFormat === 'MM/DD/YYYY') && doc[header].replace(/[0-9]/g, 'X') !== 'XX/XX/XXXX') {
                  // eslint-disable-next-line
                  errorList.push(errorLog(index + 2, t('uploadCustomerDataErrorObj.invalidDateFormatErr'), `${templateFields[key].customName}` + t('uploadCustomerDataErrorObj.invalidDateFormatDesc1') + `${templateFields[key].customFormat}` + t('uploadCustomerDataErrorObj.invalidDateFormatDesc2') + `${index + 2}`))
                }
              }
            })
          })
        }
      })

      if (errorList.length === 0) {
        setBusy()
        const arrayOfHeadersAsPerGde = []
        state.selectdTemplateFields.forEach((templateField, index) => {
          const indexOfHeaderField = headers.indexOf(templateField.label)
          const gdeFieldId = templateField.value
          if (indexOfHeaderField !== -1) {
            arrayOfHeadersAsPerGde.push(gdeFieldId)
          }
        })

        await gdeTransactions.updateJob(state.jobId, { dataUploadFields: arrayOfHeadersAsPerGde, uniqueFieldKeyToUploadData: uniqueFieldId })
        newArray.forEach(async(doc, index) => {
          let processRecord = false
          Object.keys(doc).forEach(key => {
            if ((doc[key] === '\r' || doc[key] === '' || doc[key] === undefined) && processRecord === false) {
              processRecord = false
            } else {
              processRecord = true
            }
          })

          if (processRecord) {
            const arrayOfProcessedData = {}
            state.selectdTemplateFields.forEach((templateField, index) => {
              const indexOfHeaderField = headers.indexOf(templateField.label)
              const gdeFieldId = templateField.value
              const CustomerFieldId = templateField.label
              // const customFormat = templateField.customFormat
              if (indexOfHeaderField !== -1) {
                arrayOfProcessedData[gdeFieldId] = doc[CustomerFieldId]
              }
            })
  
            const collectionData = {
              fileName: csvFile?.name,
              jobId: state?.jobId,
              originalData: doc,
              processedData: arrayOfProcessedData,
              updatedTs: new Date(),
              createdTs: new Date(),
              uploadedBy: state?.loggedInUser?.workerId,
              csvRowSrNo: index + 2,
              totalCsvRecords: newArray.length,
              uniqueCollectionId: doc[uniqueFieldCustomId],
            }
  
            await gdeTransactions.createUploadCollection(state.jobId, doc[uniqueFieldCustomId], collectionData)
          }
        })

        setTimeout(successToast({ 
          title: t('toast.successDataUpload'),
          message: t('toast.dataUploadMessage', { recordCount: newArray.length }) 
        }), 2000)

        setTimeout(() => {
          history.push(`${routePaths.AllOpenJobs}`)
        }, 2000)

        clearBusy()
      }
    }
    setErrorsList(errorList)
  }
  
  return (
    <form id="csv-form">
      <MainRouteSubRoutePage
        mainTitle='routeTitles.jobManagement'
        subTitle='forms.uploadCustomerData'
        buttons={<Buttons arrRefs={arrRefs} postService={postService} onCancelUpload={onCancelUpload} />}
      >
        <LocalToast ref={refLocalToast} />
        <FlexByRow>
          <HalfScreen>
            <TextField
              id={'assignJob_jobId'}
              data={data}
              fieldTemplate={formTemplate[SELECT_JOB_ID]}
              ref={arrRefs[SELECT_JOB_ID]}
              defaultValue={JobId}
              disabled={true}
            />
          </HalfScreen>
          <XDivider width='50px' />
          <HalfScreen>
            <Autocomplete
              id={'assignJob_uniqueFieldId'}
              data={data}
              options={state?.templateFieldsArrayForSelection}
              fieldTemplate={formTemplate[SELECT_UNIQUE_FIELD]}
              ref={arrRefs[SELECT_UNIQUE_FIELD]}
              noTranslateItems
            />
            <VerticalDivider />
          </HalfScreen>
          <XDivider width='50px' />
          <HalfScreen>
            <Label style={{ fontSize: '11px' }}>demo.selectUploadFile</Label>
            <input
              type="file"
              accept=".csv"
              id="csvFile"
              onChange={(e) => {
                setCsvFile(e.target.files[0])
              }}
            ></input>
            <br />
            <span id={'csv_file_error'} style={{ fontSize: '11px', color: '#C70039' }}></span>
          </HalfScreen>
        </FlexByRow>
        {errorsList?.length > 0
          ? <CardBodyContainer>
            <AdditionalTitle>{t('uploadCustomerDataErrorObj.mainErrorHeader1') + ' ' + t('uploadCustomerDataErrorObj.mainErrorHeader2')}</AdditionalTitle>
            <Table>
              <thead>
                <TableHeaderRow>
                  <TableHeader style={{ width: '05%', textAlign: 'center' }}><label>#</label></TableHeader>
                  <TableHeader style={{ width: '10%', textAlign: 'center' }}><label>{t('uploadCustomerDataErrorObj.tableRowNo')}</label></TableHeader>
                  <TableHeader style={{ width: '20%' }}><label>{t('uploadCustomerDataErrorObj.tableValidationType')}</label></TableHeader>
                  <TableHeader style={{ width: '65%' }}><label>{t('uploadCustomerDataErrorObj.tableValidationDetails')}</label></TableHeader>
                </TableHeaderRow>
              </thead>
              <tbody>
                {
                  errorsList.map((doc, index) => {
                    return (<TableRow key={index}>
                      <td style={{ width: '05%', textAlign: 'center' }}><label>{index + 1}</label></td>
                      <td style={{ width: '10%', textAlign: 'center' }}><label>{doc.errorRecordId}</label></td>
                      <td><label>{doc.errorType}</label></td>
                      <td><label>{doc.errorMessage}</label></td>
                    </TableRow>)
                  })
                }
              </tbody>
            </Table>
          </CardBodyContainer>
          : null}
      </MainRouteSubRoutePage>
    </form>
  )
}

export default UploadCustomerData